import ZMessage from './message.vue'

ZMessage.install = function (Vue) {
  Vue.component('z-message', ZMessage)
}

export default ZMessage
